export default __webpack_public_path__ + "f95c35f0614600825453878599de7811.svg";